import React, { useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import DataTable from "react-data-table-component";
import Loader from "../../components/components/Loader";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddBank from "./AddBank";
import UpdateBank from "./UpdateBank";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import InfoIcon from "@mui/icons-material/Info";
import DeleteDialog from "../../components/reusableComponents/DeleteDialog";
import { useHistory } from "react-router-dom";
import { BodyContainer, DTtitle, Header } from "./styles";
import { HeaderBtn, HeaderTitle } from "./styles";
import Repo from "../../Repository/Repo";
import moment from "moment/moment";

function BankAccounts() {
  const history = useHistory();
  const [records, setRecords] = useState([]);
  console.log("records:", records);
  const [addModal, setAddModal] = useState(false);
  const [remModal, setRemModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);
const companyCode = localStorage.getItem("companyCode");
  useEffect(() => {
    getBankRecords();
  }, []);

  const columns = [
    {
      name: "Bank Name",
      selector: (row) => row?.bankName,
    },
    {
      name: "Balance",
      selector: (row) => row?.balance,
    },

    {
      name: "Date",
      selector: (row) => moment(row?.date).format("DD-MM-YYYY"),
    },
    {
      name: "Action",
      cell: (row) => {
        return (
          <Stack direction="row" alignItems="center" spacing="16px">
            {/* <InfoIcon
              sx={{ color: "#4eaf51" }}
              onClick={() => handleEdit(row, "details")}
            /> */}
            <BorderColorIcon
              sx={{ color: "#4eaf51" }}
              onClick={() => handleEdit(row, "edit")}
            />
            {companyCode !== "4890" && (
              <DeleteForeverIcon
                sx={{ color: "#D35353" }}
                onClick={() => handleEdit(row, "remove")}
              />
            )}
          </Stack>
        );
      },
    },
  ];
  console.log("columns", columns);
  const handleRow = (row) => {
    history.push({
      pathname: "/inventory/admin/bank-details",
      state: { bank: row },
    });
  };

  const handleEdit = (row, type = null) => {
    console.log("rowww", row);
    setSelectedRow(row);
    if (type == "remove") {
      console.log("rem", row);
      remToggle(row);
      // handleRemove(row)
    } else if (type == "edit") {
      editToggle(row);
    } else {
      console.log("remtwo", row);

      toggle(row);
    }
  };

  const handleUpdate = (e) => {
    toggle();
    let copy = JSON.parse(JSON.stringify(records));

    let found = copy.find((i) => i.openingBalance == e.openingBalance);
    if (found) {
      found.openingBalance = e.openingBalance;
      found.date = e.date;
      found.bankName = e.bankName;
    }
    setRecords(copy);
  };

  const getBankRecords = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: "getBanksByCompany",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        setRecords(data.response.data.banks);
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const deleteBankRecords = async (row) => {
    try {
      setLoading(true);
      let { data } = await Repo.banks({
        request: {
          method: "deleteBank",
          data: {
            _id: selectedRow._id,
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        // setRecords(data.response.data.banks);
        getBankRecords();
        remToggle();
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };
  const remToggle = () => {
    setRemModal((prev) => !prev);
  };
  const editToggle = () => {
    setEditModal((prev) => !prev);
  };
  const toggle = () => {
    setAddModal((prev) => !prev);
    if (addModal) {
      setSelectedRow(null);
    }
  };

  const onSuccess = (e) => {
    // editToggle();
    getBankRecords();
  };

  const handleRemove = (row) => {
    console.log("remove", row);
    deleteBankRecords(row);
  };

  return (
    <Box>
      <Header>
        <HeaderTitle>Bank Accounts</HeaderTitle>
        <HeaderBtn variant="contained" onClick={toggle}>
          <AddCircleOutlineIcon sx={{ mr: "8px" }} /> Add New Bank
        </HeaderBtn>
      </Header>
      <BodyContainer>
        <DataTable
          title={<DTtitle>Bank Accounts List</DTtitle>}
          columns={columns}
          data={records}
          highlightOnHover={true}
          pointerOnHover={true}
          Clicked
          onRowClicked={(row) => handleRow(row)}
        />
        {loading && <Loader loading={true} />}
      </BodyContainer>

      {addModal && (
        <AddBank
          onClose={toggle}
          onSuccess={onSuccess}
          onUpdate={handleUpdate}
          row={selectedRow}
        />
      )}

      {editModal && (
        <UpdateBank
          onClose={editToggle}
          onSuccess={onSuccess}
          onUpdate={handleUpdate}
          row={selectedRow}
        />
      )}

      {remModal && (
        <DeleteDialog
          open={true}
          onClose={remToggle}
          onClickYes={handleRemove}
        />
      )}
    </Box>
  );
}

export default BankAccounts;
